export function resolveAuthEvent(authResult) {
  const info = authResult && authResult.additionalUserInfo;
  const providerId =
    (info && info.providerId) ||
    (authResult && authResult.credential && authResult.credential.signInMethod) ||
    'unknown';
  const isNewUser = !!(info && info.isNewUser);
  return {
    name: isNewUser ? 'sign_up' : 'login',
    params: { method: providerId },
  };
}

export function statusTransitionEvent(prev, next) {
  if (prev === next) return null;
  if (next === 'analyzed' || next === 'complete') {
    if (prev !== 'analyzed' && prev !== 'complete') return 'analysis_completed';
  }
  if (next === 'failed' && prev !== 'failed') return 'analysis_failed';
  return null;
}

export function editedVideoTransitionEvent(prev, next) {
  if (prev === next) return null;
  if (next === 'complete' && prev !== 'complete') return 'generation_completed';
  if (next === 'failed' && prev !== 'failed') return 'generation_failed';
  return null;
}

export function photoCompileTransitionEvent(prev, next) {
  if (prev === next) return null;
  if (next === 'complete' && prev !== 'complete') return 'photo_compile_completed';
  if (next === 'failed' && prev !== 'failed') return 'photo_compile_failed';
  return null;
}

// Bucket a raw photo count into a low-cardinality GA4 dimension. Keeping the
// distinct-value count small (vs. logging the exact number as a dimension)
// stops GA4's cardinality limits from collapsing the data, while still
// answering "how often are people uploading large batches." The exact count
// still rides along as its own numeric param for finer analysis.
export function photoCountBucket(count) {
  const n = Number(count);
  if (!Number.isFinite(n) || n <= 0) return '0';
  if (n <= 10) return '1-10';
  if (n <= 50) return '11-50';
  if (n <= 200) return '51-200';
  if (n <= 500) return '201-500';
  if (n <= 1000) return '501-1000';
  if (n <= 2000) return '1001-2000';
  // The per-project cap moved 2000 → 10000, so the old open-ended '2000+'
  // bucket now spans the entire usable range and answers nothing. Fork it at
  // the old cap, the new cap, and above (a projected total > the cap only
  // shows up on blocked batches — see photo_cap_hit). NOTE: GA4 reports
  // spanning the release will show both the retired '2000+' value and these.
  if (n <= 5000) return '2001-5000';
  if (n <= 10000) return '5001-10000';
  return '10000+';
}

export function diffSettingsForEvents(prevSettings, nextSettings, keys) {
  const events = [];
  if (!prevSettings || !nextSettings) return events;
  const list = keys || Object.keys(nextSettings);
  for (const k of list) {
    const before = prevSettings[k];
    const after = nextSettings[k];
    if (before !== after) {
      events.push({ control: k, from_value: before, to_value: after });
    }
  }
  return events;
}
